export const V1_SET_DEPARTURE_AIRPORT_SEARCH = 'V1_SET_DEPARTURE_AIRPORT_SEARCH'

export default data => {
  return {
    type: V1_SET_DEPARTURE_AIRPORT_SEARCH,
    data,
  }
}
